export const ALGORITHM_DROPDOWN = [
    { label: 'levenshtein', value: 'levenshtein' },
    // { label: 'namesim', value: 'namesim' },
    // { label: 'invert', value: 'invert' },
];

export const LEVENSHTEIN_PARAMETERS_DROPDOWN = [
    {
        label: 'levenshtein_max_distance',
        value: 'levenshtein_max_distance',
        value_type: 'number',
    },
    {
        label: 'above_score_display',
        value: 'above_score_display',
        value_type: 'number',
    },
];
